import { useDrop } from "react-dnd";

export const DroppableComponent = ({accepts, callback, children, classes = 'flex flex-col flex-1 items-center pt-[50px]', style = {}, contentEditable = false, isNumeric = false, keyLogic = (val) => {}}) => {
    const [{ isOver }, drop] = useDrop(() => ({
        accept: accepts,
        drop: (item) => {
            callback(item)
        },
        collect: (monitor) => ({
            isOver: !!monitor.isOver(),
        }),
    }));
    return (
        <div className={`${classes} ${isOver ? 'border border-[2px] border-solid border-[#0061fc]' : ''}`} ref={drop} style={style && style} contentEditable={contentEditable} suppressContentEditableWarning={true} onKeyPress={(e) => {
            if(isNumeric) {
                if (isNaN(String.fromCharCode(e.which))) e.preventDefault();
            }
        }} onKeyUp={(e) => {
            keyLogic(Number(e.target.innerHTML))
        }}>
            {children}
        </div>
    )
};